import { useSortable } from '@dnd-kit/sortable';
import type { GroupBase, MultiValueGenericProps } from 'react-select-5';
import { components } from 'react-select-5';

export function MultiValueLabel<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: MultiValueGenericProps<Option, IsMulti, Group>) {
  const { children } = props;

  const { listeners } = useSortable({
    id: props.data.value,
  });

  return (
    <components.MultiValueLabel
      {...props}
      innerProps={{
        ...props.innerProps,
        ...listeners,
        ...(typeof children === 'string' ? { title: children } : {}),
      }}
    />
  );
}
